import React from 'react';
import { Route } from 'react-router-dom';
import { Header } from '../components';
import {Footer} from '../components/footer/Footer';

/**
 * Creates a protected route wrapped with LayoutWithAppbar.
 * Requires authentication via ProtectedRoute.
 * @param path Route path string.
 * @param Component React component to render.
 * @returns A <Route> element with layout.
 */

export const createRoutesWithHeader = (path: string, Component: React.ComponentType) => (
    <Route
        key={path}
        path={path}
        element={
            <>
                <Header />
                <Component />
                <Footer />
            </>
        }
    />
)


/**
 * Creates a public route without layout or auth guard.
 * @param path Route path string.
 * @param Component React component to render.
 * @returns A public <Route> element.
 */

export const createPublicRoutes = (path: string, Component: React.ComponentType) => (
    <Route
        key={path}
        path={path}
        element={
            <Component />
        }
    />
)